import React from "react";

export default function FlightLocations(props) {
  const { offer, stations } = props;

  const outboundFlight = offer?.OfferServices?.Package?.Flight?.OutboundFlight;
  const inboundFlight = offer?.OfferServices?.Package?.Flight?.InboundFlight;

  const airports = stations?.Station;

  let outboundAirport = {};
  if (outboundFlight?.FlightDeparture) {
    outboundAirport = airports.find(
      (e) =>
        e.StationCode ===
        outboundFlight.FlightDeparture.DepartureAirportRef.AirportCode
    );
  }

  let inboundAirport = {};
  if (inboundFlight?.FlightDeparture) {
    inboundAirport = airports.find(
      (e) =>
        e.StationCode ===
        inboundFlight.FlightDeparture.DepartureAirportRef.AirportCode
    );
  }

  let outboundAirportName = outboundAirport?.Name;
  let inboundAirportName = inboundAirport?.Name;

  outboundAirportName = offer?.bookinginfo?.Offer?.Package?.Flight
    ?.OutboundFlightSegments?.DepartureAirport?._
    ? offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
        ?.DepartureAirport?._
    : outboundAirportName;
  inboundAirportName = offer?.bookinginfo?.Offer?.Package?.Flight
    ?.OutboundFlightSegments?.DepartureAirport?._
    ? offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
        ?.DepartureAirport?._
    : inboundAirportName;

  return (
    <>
      {outboundAirportName} - {inboundAirportName}
    </>
  );
}
